/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SortOrder {
    Ascending = 'Ascending',
    Descending = 'Descending'
}


export function instanceOfSortOrder(value: any): boolean {
    for (const key in SortOrder) {
        if (Object.prototype.hasOwnProperty.call(SortOrder, key)) {
            if (SortOrder[key as keyof typeof SortOrder] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SortOrderFromJSON(json: any): SortOrder {
    return SortOrderFromJSONTyped(json, false);
}

export function SortOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortOrder {
    return json as SortOrder;
}

export function SortOrderToJSON(value?: SortOrder | null): any {
    return value as any;
}

export function SortOrderToJSONTyped(value: any, ignoreDiscriminator: boolean): SortOrder {
    return value as SortOrder;
}

